import { ROLE } from "Helpers/roles/roles";
import { AdminPage } from "Pages/AdminPage/AdminPage";
import { BlankInfoPage } from "Pages/BlankInfoPage/BlankInfoPage";
import CreateProjectPage from "Pages/CreateProjectPage/CreateProjectPage";
import { LoginPage } from "Pages/LoginPage/LoginPage";
import MainPage from "Pages/MainPage/MainPage";
import { MyProjectPage } from "Pages/MyProjectPage/MyProjectPage";
import { ProjectsPage } from "Pages/ProjectsPage/ProjectsPage";
import { TelegramBlankPage } from "Pages/TelegramBlankPage/TelegramBlankPage";
import { TelegramBlanksPage } from "Pages/TelegramBlanksPage/TelegramBlanksPage";
import { WhatsNewPage } from "Pages/WhatsNewPage/WhatsNewPage";
import { Navigate } from "react-router";

export const publicRoutes = [
  {
    path: "/user/login",
    element: <LoginPage />,
  },
  {
    path: "/blank/success",
    element: <BlankInfoPage />,
  },
  {
    path: "/blank/sendback",
    element: <BlankInfoPage />,
  },
  {
    path: "*",
    element: <Navigate to="/user/login" replace />,
  },
];
export const telegramRoutes = [
  {
    path: "/telegram/blank/:projectId",
    element: <TelegramBlankPage />,
  },
  {
    path: "/telegram/blank/:projectId/saved",
    element: <TelegramBlanksPage />,
  },
];

export const privateRoutes = [
  {
    path: "/",
    element: <MainPage />,
  },
  {
    path: "/whats-new",
    element: <WhatsNewPage />,
  },
  {
    path: "/admin/users",
    element: <AdminPage type="users" />,
    roles: [ROLE.ADMIN],
  },
  {
    path: "/admin/jobs",
    element: <AdminPage type="jobs" />,
    roles: [ROLE.ADMIN],
  },
  {
    path: "/projects/my",
    element: <ProjectsPage type="my" />,
    roles: [ROLE.ENGINEER, ROLE.ADMIN, ROLE.MANAGER, ROLE.WORKER],
  },
  {
    path: "/projects/all",
    element: <ProjectsPage type="all" />,
    roles: [ROLE.ADMIN],
  },
  {
    path: "/projects/create",
    element: <CreateProjectPage />,
    roles: [ROLE.ADMIN, ROLE.ENGINEER],
  },
  {
    path: "/projects/:projectId",
    element: <MyProjectPage />,
    roles: [ROLE.ADMIN, ROLE.ENGINEER, ROLE.MANAGER, ROLE.WORKER],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export const ProtectedRoute = ({ children, isAuth }) => {
  return isAuth ? children : <Navigate to="/user/login" replace />;
};

export const RoleGuard = ({ children, rolesAccessArray, userRoles }) => {
  if (!rolesAccessArray) return children;

  const isApprowedAccess = rolesAccessArray.some((accessRole) => {
    return userRoles.includes(accessRole);
  });
  if (!isApprowedAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
};
